import React from "react";
import Dashboard from "./Dashboard";
import Patent from "./Patent";

const Dash_Patent = () => {
  return (
    <>
      <Dashboard />
      <Patent />
    </>
  );
};

export default Dash_Patent;
